import React from 'react'

const AddFestival = () => {
  return (
    <div>AddFestival</div>
  )
}

export default AddFestival